import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processTeam = (store, item) => {
    item.users = _.map(item.users, 'id')
    item.users_count = item.users.length

    store.commit(mutations.ADD_OR_UPDATE_TEAM, item)
}

export const fetchTeams = (store, params = {}) => {
    return axios.get(`/api/teams`, {params})
        .then(res => {
            _.each(res.data.data, item => processTeam(store, item))
            return res
        })
}

export const createTeam = (store, item) => {
    return axios.post('/api/teams', item)
        .then(res => {
            processTeam(store, res.data.data)
            return res
        })
}

export const updateTeam = (store, item) => {
    return axios.patch(`/api/teams/${item.id}`, item)
        .then(res => {
            processTeam(store, res.data.data)
            return res
        })
}

export const createOrUpdateTeam = (store, item) => {
    return item.id ?
        updateTeam(store, item) :
        createTeam(store, item)
}

export const removeTeam = (store, item) => {
    return axios.delete(`/api/teams/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_TEAM, item)
            return res
        })
}
